import React, { useEffect } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { X } from "lucide-react";
import { getCeliaMeetingEmbedUrl } from "@/components/thales/celiaMeeting";
import { trackPostHogEvent } from "@/lib/analytics";
import { useArkemaLang } from "@/components/thales/i18n";

interface CeliaMeetingModalProps {
  isOpen: boolean;
  onClose: () => void;
  location?: string;
}

const CeliaMeetingModal: React.FC<CeliaMeetingModalProps> = ({
  isOpen,
  onClose,
  location = "unknown",
}) => {
  const { lang } = useArkemaLang();

  useEffect(() => {
    if (isOpen) {
      trackPostHogEvent("siemens_meeting_modal_opened", {
        page: "siemens",
        location,
        lang,
      });
    }
  }, [isOpen, location, lang]);

  useEffect(() => {
    if (!isOpen) return;
    const onMessage = (event: MessageEvent) => {
      const data = event.data as { meetingBookSucceeded?: boolean } | undefined;
      if (data && data.meetingBookSucceeded === true) {
        trackPostHogEvent("siemens_meeting_booked", {
          page: "siemens",
          location,
          lang,
        });
      }
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, [isOpen, location, lang]);

  return (
    <Dialog open={isOpen} onOpenChange={(o) => !o && onClose()}>
      <DialogContent
        className="max-w-4xl w-[95vw] h-[85vh] p-0 overflow-hidden"
        style={{ zIndex: 100000 }}
      >
        <button
          onClick={onClose}
          className="absolute right-3 top-3 z-10 rounded-full bg-white/90 hover:bg-white p-1.5 shadow"
          aria-label="Fermer"
        >
          <X className="h-4 w-4" />
        </button>
        <iframe
          src={getCeliaMeetingEmbedUrl(lang)}
          title="Réserver un créneau avec Célia"
          className="w-full h-full border-0"
        />
      </DialogContent>
    </Dialog>
  );
};

export default CeliaMeetingModal;